module.exports = __webpack_public_path__ + "img/gygx_08.da2fda0d.jpg";